import { render, staticRenderFns } from "./PuzzleListTable.vue?vue&type=template&id=6a8b6b08&scoped=true&lang=html&"
import script from "./PuzzleListTable.vue?vue&type=script&lang=js&"
export * from "./PuzzleListTable.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleListTable.vue?vue&type=style&index=0&id=6a8b6b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b6b08",
  null
  
)

export default component.exports